import type {
  RefundRequestDetail,
  RefundRequestListParams,
  RefundRequestListResponse,
  RefundRequestSummary,
} from "@/@types/RefundRequest";
import { api } from "./api";

const BASE_URL = "/v1/disputes/refunds";

async function getSummary(currency: string): Promise<RefundRequestSummary> {
  const response = await api.get<{ data: RefundRequestSummary }>(`${BASE_URL}/summary`, {
    params: { currency },
  });
  return response.data.data;
}

async function list(params: RefundRequestListParams): Promise<RefundRequestListResponse> {
  const response = await api.get<RefundRequestListResponse>(BASE_URL, {
    params: {
      status: params.status,
      q: params.q || undefined,
      page: params.page,
      per_page: params.per_page,
    },
  });
  return response.data;
}

async function show(id: string): Promise<RefundRequestDetail> {
  const response = await api.get<{ data: RefundRequestDetail }>(`${BASE_URL}/${id}`);
  return response.data.data;
}

async function approve(id: string): Promise<RefundRequestDetail> {
  const response = await api.post<{ data: RefundRequestDetail }>(`${BASE_URL}/${id}/approve`);
  return response.data.data;
}

async function startMediation(id: string): Promise<RefundRequestDetail> {
  const response = await api.post<{ data: RefundRequestDetail }>(`${BASE_URL}/${id}/mediation`);
  return response.data.data;
}

async function sendMessage(id: string, body: string, attachment?: File | null): Promise<RefundRequestDetail> {
  const formData = new FormData();
  formData.append("body", body);
  if (attachment) formData.append("attachment", attachment);

  const response = await api.post<{ data: RefundRequestDetail }>(`${BASE_URL}/${id}/messages`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data.data;
}

async function downloadAttachment(id: string, messageId: number): Promise<Blob> {
  const { data } = await api.get(`${BASE_URL}/${id}/messages/${messageId}/attachment`, {
    responseType: "blob",
  });
  return data;
}

export const RefundRequestsService = {
  getSummary,
  list,
  show,
  approve,
  startMediation,
  sendMessage,
  downloadAttachment,
};
